/**
 * Data simulada de `obtener_boletas_mnt` / `obtiene_factura` mientras los
 * webservices no estén publicados. Se activa con REACT_APP_MOCK_DOCUMENTOS y
 * respeta la forma que se espera del backend (`status` / `result`), así al
 * apagar el flag no hay que tocar las vistas. Borrar este archivo junto con el
 * flag.
 */

const MOVIMIENTO_BASE = 16389295;

/**
 * Escenarios que recorre el mock, uno por contrato en orden de aparición, para
 * que en pantalla se vean todos los casos: con boletas y factura, sin boletas,
 * y sin factura. Con un hash sobre el número de contrato no alcanzaba: los
 * contratos son casi idénticos entre sí y caían siempre en el mismo caso.
 */
const ESCENARIOS = [
  { boletas: 3, factura: true },
  { boletas: 0, factura: true },
  { boletas: 2, factura: false },
  { boletas: 1, factura: true },
  { boletas: 0, factura: false },
];

const INDICES = {};
let proximoIndice = 0;

/**
 * Índice estable por contrato. Se asigna la primera vez que se pide y se
 * conserva, así boletas y factura del mismo contrato ven el mismo escenario.
 */
function indice(contrato) {
  const clave = String(contrato || '');
  if (!(clave in INDICES)) {
    INDICES[clave] = proximoIndice++;
  }
  return INDICES[clave];
}

function escenario(contrato) {
  return ESCENARIOS[indice(contrato) % ESCENARIOS.length];
}

function demora(respuesta) {
  return new Promise((resolve) => setTimeout(() => resolve(respuesta), 600));
}

export function MockBoletasMantencion({ contrato }) {
  const total = escenario(contrato).boletas;
  const boletas = [];
  for (let cuota = 1; cuota <= total; cuota++) {
    boletas.push({
      contrato: contrato,
      cuota: cuota,
      movimiento: String(MOVIMIENTO_BASE + indice(contrato) * 100 + cuota),
    });
  }
  return demora({ status: 'success', result: { boletas: boletas } });
}

export function MockFactura({ contrato }) {
  const tiene = escenario(contrato).factura;
  return demora({
    status: 'success',
    result: { factura: tiene ? { contrato: contrato } : null },
  });
}
